<template>
  <section id="pipeline" style="margin-bottom: 30px">
    <div class="row">
      <div class="col-md-12">
        <div class="card mt-1" style="margin: 0">
          <div class="pipeline-controls desktop-only m-3">
            <h6 style="font-weight: 700">Pipelines</h6>
            <div class="controls-wrap d-flex align-items-center no-mobile">
              <div class="input-group">
                <Search placeholderText="Search (name)" @search="handleSearch" />

                <!-- <DropdownCheckbox
                  style="min-width: 250px"
                  :options="[
                    { id: 101, stage: 'Not submitted' },
                    { id: 102, stage: 'Not contacted' },
                    { id: 103, stage: 'Contacted' },
                    { id: 104, stage: 'Interviewing' },
                    { id: 106, stage: 'Offered employment' },
                    { id: 107, stage: 'Employed' },
                    { id: 108, stage: 'No longer interested' },
                    { id: 109, stage: 'Not in consideration' },
                  ]"
                  @item-selected="handleStageFilter"
                  v-model="selectedStages"
                  name="manager-pipeline-stage-filter"
                  :isLoading="isLoading"
                  placeholder="Stage"
                  label="stage"
                /> -->

                <DropdownCheckbox
                  style="min-width: 250px"
                  :options="[
                    { id: 102, stage: 'Not contacted' },
                    { id: 103, stage: 'Contacted' },
                    { id: 104, stage: 'Interviewing' },
                    { id: 106, stage: 'Offered employment' },
                    { id: 107, stage: 'Employed' },
                    { id: 108, stage: 'No longer interested' },
                    { id: 109, stage: 'Not in consideration' },
                  ]"
                  v-model="selectedStages"
                  @input="handleStageFilter"
                  name="pipeline-stage-filter"
                  placeholder="Stage"
                  label="stage"
                />
              </div>

              <!--   <button
                data-toggle="modal"
                data-target="#jobPipelineAddExistingCandidateModal"
                type="button"
                class="btn btn-primary mr-3 ml-3"
                style="white-space: nowrap"
              >
                Add Existing Candidate
              </button> -->

              <!-- Add Existing Candidate Modal -->
              <div
                class="modal fade edit-modal"
                id="jobPipelineAddExistingCandidateModal"
                tabindex="-1"
                aria-labelledby="jobPipelineAddExistingCandidateModalLabel"
                aria-hidden="true"
                role="dialog"
                data-backdrop="static"
              >
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">Add Existing Candidate</h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <div class="modal-body existing-candidate text-center justify-content-center">
                      <v-select
                        v-model="listOfSelectedCandidates"
                        @search="handleSelectedCandidates"
                        :options="getExistingCandidates"
                        placeholder="Select Existing Candidate"
                        label="first_name"
                        :reduce="candidates => candidates"
                        :clearable="false"
                      >
                        <template #option="{ first_name, last_name, email }">
                          {{ first_name }} {{ last_name }} - <em>{{ email }}</em>
                        </template>
                        <template #selected-option="{ first_name, last_name, email }">
                          {{ first_name }} {{ last_name }} - {{ email }}
                        </template>
                        <template v-slot:no-options="{ search, searching }">
                          <template v-if="searching && search.length >= 3">
                            No results found for <em>{{ search }}</em
                            >.
                          </template>
                          <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                        </template>
                      </v-select>

                      <select v-model="sources" class="form-control my-3">
                        <option v-for="source in getSourceList" :value="source.id" :key="source.id">
                          {{ source.source }}
                        </option>
                      </select>
                    </div>

                    <div class="modal-footer text-center justify-content-center">
                      <button
                        type="button"
                        class="btn btn-primary"
                        data-dismiss="modal"
                        @click="onAddExistingCandidate(listOfSelectedCandidates, sources)"
                      >
                        Add
                      </button>

                      <button type="button" class="btn btn-secondary" data-dismiss="modal">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End Add Existing Candidate Modal -->

              <!-- <button
                @click="showModal = true"
                type="button"
                class="btn btn-success"
                style="white-space: nowrap"
              >
                Add New Candidate
                <portal to="add-candidate-modal">
                  <CustomMainModal @close="closeModal" v-show="showModal">
                    <template v-slot:header>
                      <h5>Add Candidate</h5>
                    </template>

                    <AddCandidateBtnModal :job_uuid="this.$route.params.job_uuid" />
                  </CustomMainModal>
                </portal>
              </button> -->
              <!--   <portal-target name="add-candidate-modal"></portal-target> -->
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-striped table-responsive custom-table">
              <thead class="bg-dark text-white">
                <tr>
                  <th scope="col" style="width: 12%">RATING</th>
                  <th scope="col" style="width: 20%">NAME</th>
                  <th scope="col">LOCATION</th>
                  <th nowrap scope="col" style="font-weight: 600">&nbsp;</th>
                  <th scope="col">DOCUMENTS</th>
                  <th scope="col">ADDED</th>
                  <th scope="col">STAGE</th>
                  <th scope="col">ACTIONS</th>
                </tr>
              </thead>

              <tbody>
                <PipelineItem
                  v-for="pipeline in getManagerJobPipelines.data"
                  :key="pipeline.id"
                  :pipeline="pipeline"
                  :user="getUserProfile"
                  :jobad="getManagerJobByID"
                  v-on:pipeline-update="updatePipeline"
                  @activity="$emit('newActivity')"
                />
              </tbody>
            </table>

            <ErrorList
              class="no-data-message p-5"
              v-show="getManagerJobPipelines.data.length === 0"
              name="noPipelines"
            />
          </div>

          <Spinner :isLoading="isLoading" />

          <!-- Edit Modal -->
          <div
            class="modal fade edit-modal"
            id="editJobPipeline"
            tabindex="-1"
            aria-labelledby="editJobPipeline"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="editJobPipelinelineLabel">Edit Pipeline</h5>
                  <button
                    ref="closeEditModal"
                    type="button"
                    @click="clearForm"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="d-flex align-items-center">
                    <div class="form-group flex-grow-1 mr-2">
                      <select
                        class="form-control my-3"
                        v-model="stage"
                        @change="onStageChange($event)"
                      >
                        <option value="not_contacted">Not contacted</option>
                        <option value="contacted">Contacted</option>
                        <option value="interviewing">Interviewing</option>
                        <option value="offered_employment">Offered employment</option>
                        <option value="employed">Employed</option>
                        <option value="no_longer_interested">No longer interested</option>
                        <option value="not_in_consideration">Not in consideration</option>
                      </select>

                      <div class="form-group">
                        <textarea
                          v-model="comment"
                          class="form-control"
                          style="min-height: 3rem"
                          id="manager-job-comment-textarea"
                          rows="1"
                          placeholder="Comment"
                          :disabled="isSubmitted === false"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal-footer text-center justify-content-center">
                  <button @click="onUpdatePipeline" type="button" class="btn btn-primary">
                    Save changes
                  </button>
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- End Edit Modal -->

          <!-- Submit Modal -->
          <div
            class="modal fade"
            id="submitJobModal"
            tabindex="-1"
            aria-labelledby="submitJobModal"
            aria-hidden="true"
            data-backdrop="static"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="submitJobModalLabel">Submit Candidate</h5>
                  <button
                    ref="closeEditModal"
                    type="button"
                    @click="clearForm"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="d-flex align-items-center">
                    <p>
                      Please confirm that
                      <b>{{ pipelineForSubmit.first_name }} {{ pipelineForSubmit.last_name }}</b>
                      should be submitted for the role <b> {{ getJobAdById.title }}</b
                      >, <b>{{ getJobAdById.employer_name }}</b>
                    </p>
                  </div>
                </div>

                <div class="modal-footer text-center justify-content-center">
                  <button @click="onUpdatePipeline()" type="button" class="btn btn-primary">
                    Submit
                  </button>
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- End Submit Modal -->

          <!-- Delete Modal -->
          <div
            class="modal fade edit-modal"
            id="candidatePipelineDeleteModal"
            tabindex="-1"
            aria-labelledby="candidatePipelineDeleteModal"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="editModal2Label">Remove from Pipeline</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body text-center justify-content-center">
                  <p>
                    {{ 'Please confirm that you want to remove the candidate from this pipeline.' }}
                  </p>
                </div>
                <div class="modal-footer text-center justify-content-center">
                  <button
                    @click="onDeletePipeline"
                    type="button"
                    class="btn btn-primary"
                    data-dismiss="modal"
                  >
                    Delete
                  </button>

                  <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- End Delete Modal -->

          <!-- Pagination -->
          <div class="d-flex justify-content-between bottom-controls">
            <div class="ml-auto mb-4">
              <Pagination
                :currentPage="getCurrentPage"
                :totalPages="getTotalPages"
                @nextPage="nextPage"
                @prevPage="previousPage"
                @keyup="keymonitor"
                @selectPageByNumber="setPageBynumber"
                @firstPage="setToFirstPage"
                @lastPage="setToLastPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Search from '../../common/Search/Search';

/* import JobStatusSelect from '../../common/JobStatusSelect'; */
/* import CustomMainModal from '../../Modals/CustomMainModal';
import AddManagerJobBtnModal from '../Jobs/AddManagerJobBtnModal'; */
import DropdownCheckbox from '../../common/DropdownCheckbox/DropdownCheckbox';
import ErrorList from '@/components/common/errorsList';
import Pagination from '@/components/Navigations/Pagination';
import { stagesMixin } from '../../../mixins/stagesMixin';
import { qualificationMixin } from '../../../mixins/qualificationMixin';
import PipelineItem from './ManagerJobItemPipelineTableItem';
import { errorService } from '../../../services/errorService';

export default {
  components: {
    Search,
    PipelineItem,
    /* JobStatusSelect, */
    /* CustomMainModal,
    AddManagerJobBtnModal, */
    Pagination,
    ErrorList,
    DropdownCheckbox,
  },
  mixins: [stagesMixin, qualificationMixin],
  data: () => ({
    /*   searchText: '', */
    selectedStages: [],
    rating: {},
    listOfSelectedSources: [],
    employerPipelineSourcesOptions: [],
    qualification: 'qualification',
    stage: [],
    starPoints: [23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17],
    listOfSelectedCandidates: [],
    existingCandidatesOptions: [],
    showModal: false,
    count: 10,
    sources: '',
    isLoading: false,
    isSubmitted: false,
    comment: '',
    selectedDocuments: [],
    pipelineForSubmit: {},
    searchPhrase: '',
    /* Pagination */
    getCurrentPage: 1,
    getTotalPages: 0,
  }),
  methods: {
    ...mapActions('managerStoreModule', [
      'retrieveJobsPipeline',
      'retrieveSourcesList',
      'retrieveExistingCandidates',
      'addExistingCandidate',
      'retrieveManagerJobPipelines',
      'updateManagerJobPipeline',
    ]),
    onStageChange() {
      this.isSubmitted = true;
    },
    onUpdatePipeline() {
      this.isSubmitted = false;

      this.updateManagerJobPipeline({
        pipeline_id: this.pipelineForUpdate,
        stage: this.stage,
      }).then(() => {
        this.$emit('activity');
      });
    },
    getDocumentProperties(fileName) {
      const re = /(?:\.([^.]+))?$/;
      if (re.exec(fileName)[1] === 'pdf') {
        return {
          color: '#ff0000',
          type: 'pdf',
        };
      } else if (re.exec(fileName)[1] === 'docx' || re.exec(fileName)[1] === 'doc') {
        return {
          color: '#005a9e',
          type: 'doc',
        };
      } else {
        return { color: '#a7a7a77', type: '' };
      }
    },
    setPipelineForSubmit(pipeline) {
      this.pipelineForSubmit = pipeline;
    },
    setPipelineForDelete(pipeline) {},
    onDeletePipeline(pipeline) {},
    clearForm() {},
    setCurrentSelectedRating(rating, pipelineId) {
      this.setCandidatePipelineRating({ rating, pipeline_id: pipelineId })
        .then(() => {
          this.retrieveCandidatePipelines({ uuid: this.$route.params.candidate_id });
        })
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    onAddExistingCandidate(candidatesList, source) {
      this.addExistingCandidate({
        jobad_id: this.$route.params.job_uuid,
        candidate_id: candidatesList.id,
        source_id: source,
      });
    },
    handleSelectedCandidates(search, loading) {
      if (search.length >= 3) {
        loading(true);

        this.retrieveExistingCandidates({
          search_word: search,
        });
      }

      loading(false);
    },
    closeModal() {
      this.getCurrentPage = 1;
      this.showModal = false;
    },
    doSearch() {
      this.getCurrentPage = 1;

      if (this.searchPhrase.length >= 3) {
        this.isLoading = true;

        this.retrieveManagerJobPipelines({
          jobad_id: this.$route.params.manager_job_uuid,
          search_word: this.searchPhrase,
          stage: this.selectedStages.map(stage => stage.id),
          page: this.getCurrentPage,
          count: this.count,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;

            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }

      if (this.searchPhrase === '') {
        this.isLoading = true;

        this.retrieveManagerJobPipelines({
          jobad_id: this.$route.params.manager_job_uuid,
          search_word: this.searchPhrase,
          stage: this.selectedStages.map(stage => stage.id),
          page: this.getCurrentPage,
          count: this.count,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;

            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },
    nextPage() {
      if (this.getCurrentPage >= 1 && this.getCurrentPage < this.getTotalPages) {
        this.isLoading = true;
        this.getCurrentPage++;

        /*  const stagesList = Object.keys(this.stages).map((key) => ({
          id: key,
          value: this.stages[key],
        })); */

        this.retrieveManagerJobPipelines({
          jobad_id: this.$route.params.manager_job_uuid,
          search_word: this.searchPhrase,
          stage: this.selectedStages.map(stage => stage.id),
          page: this.getCurrentPage,
          count: this.count,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    previousPage() {
      if (this.getCurrentPage > 1) {
        this.isLoading = true;
        --this.getCurrentPage;

        /* const stagesList = Object.keys(this.stages).map((key) => ({
          id: key,
          value: this.stages[key],
        })); */

        this.retrieveManagerJobPipelines({
          jobad_id: this.$route.params.manager_job_uuid,
          search_word: this.searchPhrase,
          stage: this.selectedStages.map(stage => stage.id),
          page: this.getCurrentPage,
          count: this.count,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        this.getCurrentPage = 1;
      }
    },
    setToFirstPage() {
      this.isLoading = true;
      this.getCurrentPage = 1;

      /*   const stagesList = Object.keys(this.stages).map((key) => ({
        id: key,
        value: this.stages[key],
      })); */

      this.retrieveManagerJobPipelines({
        jobad_id: this.$route.params.manager_job_uuid,
        search_word: this.searchPhrase,
        stage: this.selectedStages.map(stage => stage.id),
        page: this.getCurrentPage,
        count: this.count,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.getCurrentPage = lastPage;

      /*   const stagesList = Object.keys(this.stages).map((key) => ({
        id: key,
        value: this.stages[key],
      })); */

      this.retrieveManagerJobPipelines({
        jobad_id: this.$route.params.manager_job_uuid,
        search_word: this.searchPhrase,
        stage: this.selectedStages.map(stage => stage.id),
        page: this.getCurrentPage,
        count: this.count,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    setPageBynumber(pageNumber) {
      if (pageNumber > this.getTotalPages || pageNumber < 1) return;
      this.getCurrentPage = Number(pageNumber);
      this.isLoading = true;
      /*   const stagesList = Object.keys(this.stages).map((key) => ({
        id: key,
        value: this.stages[key],
      })); */

      this.retrieveManagerJobPipelines({
        jobad_id: this.$route.params.manager_job_uuid,
        search_word: this.searchPhrase,
        stage: this.selectedStages.map(stage => stage.id),
        page: this.getCurrentPage,
        count: this.count,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        this.previousPage();
      }
    },
    handleStageFilter(stages) {
      this.selectedStages = stages;
      this.doSearch();
    },
    handleSearch(searchPhrase) {
      this.searchPhrase = searchPhrase;
      this.doSearch();
    },

    updatePipeline() {
      this.retrieveManagerJobPipelines({
        jobad_id: this.$route.params.manager_job_uuid,
        search_word: this.searchPhrase,
        stage: this.selectedStages.map(stage => stage.id),
        page: this.getCurrentPage,
        count: this.count,
      });
    },
  },
  computed: {
    ...mapGetters('managerStoreModule', [
      'getManagerJobPipelines',
      'getManagerJobByID',
      'getManagerProfile',
      'getManagerUserProfile',
    ]),
    ...mapGetters([
      'getUserProfile',
      'getSourceList',
      'getPipelines',
      'getExistingCandidates',
      'getJobAdById',
    ]),
  },
  mounted() {
    /* jobad_id: payload.jobad_id,
          search_word: payload.search_text,
          stage: payload.stage,
          count: payload.count,
          page: payload.page, */

    this.retrieveManagerJobPipelines({
      jobad_id: this.$route.params.manager_job_uuid,
      search_word: this.searchPhrase,
      stage: this.selectedStages.map(stage => stage.id),
      page: this.getCurrentPage,
      count: this.count,
    }).then(() => {
      this.getTotalPages = this.getManagerJobPipelines.last_page;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.icon-wrapper {
  .svg-icon {
    width: 18px;
    height: 18px;
  }
  .edit {
    fill: #a7a7a7;
  }

  .submit {
    fill: #5bb75b;
  }
}

/* Stages */

#pipeline {
  overflow: hidden;
}

.dropdown {
  button {
    box-shadow: 0px 2px 3px #0000000d;
    background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='14' height='14' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='grey'/></g></svg>")
      no-repeat !important;
    background-position: right 3px top 50% !important;
    margin-right: 8px !important;
    -webkit-appearance: none;
    -moz-appearance: none;

    &::after {
      display: none;
      /*  -webkit-appearance: none;
      -moz-appearance: none; */
    }
    color: #4d4f5c;
  }

  .dropdown-menu {
    padding: 8px 12px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
    ul > li:not(:last-child) {
      margin-bottom: 1rem;
    }

    width: 250px;
    margin-top: 5px;

    .custom-control {
      margin-bottom: 0;
    }
  }

  button {
    background-color: #fff;
    border: 1px solid #d7dae2;
    border-radius: 4px;
    width: 250px;
    text-align: left;
  }
}

h6 {
  font-size: 18px;
}
.star-rating {
  position: relative;
  display: block;
  width: 100%;
  .reset-stars {
    position: absolute;
    font-size: 16.7px;
    cursor: pointer;
    top: 0px;
    right: -8px;
    color: #555;
    display: none;
  }
  &:hover {
    .reset-stars {
      display: block;
    }
  }
}

.custom-table {
  display: table;
}

.mobile-only {
  display: none !important;
}

@media only screen and (max-width: 768px) {
  #stages-dropdown {
    flex: 1;
    .dropdown-toggle {
      width: 100%;
    }
  }
  .btn-success {
    display: none !important;
  }
}

@media only screen and (max-width: 576px) {
  .dropdown.ml-3 {
    margin-left: 0 !important;
    .btn {
      width: 100%;
      margin: 12px 0;
    }
  }
}
/* End Stages */

@media only screen and (max-width: 992px) {
  .card {
    border-radius: 0;
    margin-top: 12px !important;
    border: none;
    h6 {
      margin: 0 12px 0px 25px;
      font-size: 18px;
    }
    .mx-2 {
      margin: 0 !important;
    }
    .col-md-12 {
      padding: 0;
    }
    .my-4 {
      margin: 0 !important;
    }
    .pipeline-controls {
      margin: 0 !important;
      padding: 0 12px;
      .no-mobile {
        display: none !important;
      }
    }
    .controls-wrap {
      display: block !important;
      .form-control {
        margin: 12px 0 !important;
      }
      .select-style {
        display: block;
        width: 100% !important;
      }
      .btn-primary,
      .btn-success {
        width: 48%;
        text-align: center;
        margin-bottom: 12px;
        i {
          display: none;
        }
      }
    }
  }
  .bottom-controls,
  .no-mobile {
    display: none !important;
  }
  .list-unstyled.mobile-pipeline {
    margin-top: -10px;
    padding: 0 25px;
    font-family: $font-family-sans-lato;
    li {
      position: relative;
      padding: 6px 20px 6px 20px;
      border-bottom: 1px solid #ddd;
      a.username {
        display: block;
        font-size: 16px;
        font-weight: 700;
        text-decoration: none;
      }

      a.toggle-collapse {
        color: #666;
        position: absolute;
        top: 50%;
        right: -2px;
        transform: translate(0, -50%);
      }

      .d-flex:first-of-type {
        span {
          font-size: 14px;
          &:first-of-type {
            color: $color-orange;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
          }
        }
      }

      .d-flex:nth-of-type(2) {
        span {
          font-size: 14px;

          &:first-of-type {
            color: #5f5f5f;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
            position: relative;
            .status {
              border-radius: 50%;
              display: inline-block;
              width: 11px;
              height: 11px;
              background: red;
              margin: 0px 5px 0 0;
              &.employment {
                background: $color-status-active;
              }
              &.self-employment {
                background: $color-base-blue;
              }
              &.mixed-orange {
                background: $color-orange;
              }
            }
          }
        }
      }
      img {
        position: absolute;
        top: 8px;
        right: 12px;
      }
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
  .custom-table {
    display: block !important;
  }
}

@media only screen and (max-width: 768px) {
  .card {
    border-radius: 0;
    margin-top: 12px !important;
    border: none;
    h6 {
      margin: 0 12px 0px 25px;
      font-size: 18px;
    }
    .mx-2 {
      margin: 0 !important;
    }
    .col-md-12 {
      padding: 0;
    }
    .my-4 {
      margin: 0 !important;
    }
    .pipeline-controls {
      margin: 0 !important;
      padding: 0 12px;
      .no-mobile {
        display: none !important;
      }
    }
    .controls-wrap {
      display: block !important;
      .form-control {
        margin: 12px 0 !important;
      }
      .select-style {
        display: block;
        width: 100% !important;
      }
      .btn-primary,
      .btn-success {
        width: 48%;
        text-align: center;
        margin-bottom: 12px;
        i {
          display: none;
        }
      }
    }
  }
  .bottom-controls,
  .no-mobile {
    display: none !important;
  }
  .list-unstyled.mobile-pipeline {
    margin-top: -10px;
    padding: 0 25px;
    font-family: $font-family-sans-lato;
    li {
      position: relative;
      padding: 6px 20px 6px 20px;
      border-bottom: 1px solid #ddd;
      a.username {
        display: block;
        font-size: 16px;
        font-weight: 700;
        text-decoration: none;
      }

      a.toggle-collapse {
        color: #666;
        position: absolute;
        top: 50%;
        right: -2px;
        transform: translate(0, -50%);
      }

      .d-flex:first-of-type {
        span {
          font-size: 14px;
          &:first-of-type {
            color: $color-orange;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
          }
        }
      }

      .d-flex:nth-of-type(2) {
        span {
          font-size: 14px;

          &:first-of-type {
            color: #5f5f5f;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
            position: relative;
            .status {
              border-radius: 50%;
              display: inline-block;
              width: 11px;
              height: 11px;
              background: red;
              margin: 0px 5px 0 0;
              &.employment {
                background: $color-status-active;
              }
              &.self-employment {
                background: $color-base-blue;
              }
              &.mixed-orange {
                background: $color-orange;
              }
            }
          }
        }
      }
      img {
        position: absolute;
        top: 8px;
        right: 12px;
      }
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
}

@media only screen and (max-width: 576px) {
  .card {
    border-radius: 0;
    margin-top: 12px !important;
    border: none;
    h6 {
      margin: 0 12px 0px 25px;
      font-size: 18px;
    }
    .mx-2 {
      margin: 0 !important;
    }
    .col-md-12 {
      padding: 0;
    }
    .my-4 {
      margin: 0 !important;
    }
    .pipeline-controls {
      margin: 0 !important;
      padding: 0 12px;
      .no-mobile {
        display: none !important;
      }
    }
    .controls-wrap {
      display: block !important;
      .form-control {
        margin: 12px 0 !important;
      }
      .select-style {
        display: block;
        width: 100% !important;
      }
      .btn-primary,
      .btn-success {
        width: 48%;
        text-align: center;
        margin-bottom: 12px;
        i {
          display: none;
        }
      }
    }
  }
  .bottom-controls,
  .no-mobile {
    display: none !important;
  }
  .list-unstyled.mobile-pipeline {
    position: relative;
    margin: -4px 0 0 0;
    padding: 0 25px;
    font-family: $font-family-sans-lato;
    li {
      position: relative;
      padding: 6px 12px 6px 8px;
      border-bottom: 1px solid #ddd;
      a.username {
        display: block;
        font-size: 16px;
        font-weight: 700;
        text-decoration: none;
      }

      a.toggle-collapse {
        color: #666;
        position: absolute;
        top: 50%;
        right: -2px;
        transform: translate(0, -50%);
      }

      .d-flex:first-of-type {
        span {
          font-size: 14px;
          &:first-of-type {
            color: $color-orange;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
          }
        }
      }

      .d-flex:nth-of-type(2) {
        span {
          font-size: 14px;

          &:first-of-type {
            color: #5f5f5f;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
            position: relative;
            .status {
              border-radius: 50%;
              display: inline-block;
              width: 11px;
              height: 11px;
              background: red;
              margin: 0px 5px 0 0;
              &.employment {
                background: $color-status-active;
              }
              &.self-employment {
                background: $color-base-blue;
              }
              &.mixed-orange {
                background: $color-orange;
              }
            }
          }
        }
      }
      img {
        position: absolute;
        top: 8px;
        right: 12px;
      }
    }
  }
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block !important;
  }
}
</style>
